import { NestedRoutes } from "../../../app/routes.types";
import { Roles } from ".";
import RolesIcon from "../../../assets/Admin/Roles";
import { AddRoleForm } from "./AddRole";
import { EditRoleForm } from "./EditRole";
import { AddTeamMember } from "./AddTeamMember";
import { Api } from "../../../services/api";
import { UserPermissions } from "../../../enums";

export const RolesRoutes: NestedRoutes = {
  icon: RolesIcon,
  name: "Roles",
  path: "roles",
  component: Roles,
  permissions: [UserPermissions.RoleViewList],
  children: [
    {
      name: "Add",
      path: "add",
      component: AddRoleForm,
      permissions: [UserPermissions.RoleAddRole],
    },
    {
      path: ":roleId",
      getName: async (params: Record<string, string>) => {
        return await Api.roles.getRole(params.roleId).then(res => {
          return res.data.name;
        });
      },
      permissions: [
        UserPermissions.RoleViewDetails,
        UserPermissions.RoleManageDetails,
      ],
      children: [
        {
          name: "Edit",
          path: "edit",
          component: EditRoleForm,
          permissions: [
            UserPermissions.RoleViewDetails,
            UserPermissions.RoleManageDetails,
          ],
        },
        {
          name: "Add Members",
          path: "addMember",
          component: AddTeamMember,
          permissions: [UserPermissions.RoleManageMembers],
        },
      ],
    },
  ],
};
